import { events, EventsParam } from '../../api/events';
import { Event } from '../../interfaces/events';

async function fetchEvents(params: EventsParam): Promise<Event[]> {
	try {
		return await events.getEvents(params);
	} catch (error) {
		throw error;
	}
}

async function fetchEventsDevice(deviceId: number, params: EventsParam): Promise<Event[]> {
	try {
		return await events.getEventsDevice(deviceId, params);
	} catch (error) {
		throw error;
	}
}

async function fetchEventsLast(params: EventsParam): Promise<Event[]> {
	try {
		return await events.getEventsLast(params);
	} catch (error) {
		throw error;
	}
}

export const eventsService = {
	fetchEvents,
	fetchEventsDevice,
	fetchEventsLast,
};
